module.exports = __webpack_public_path__ + "img/way_g_ag.e6a28fed.png";